import { z } from 'zod';
import { ACCOUNTING_TAGS } from '../accounting/categories.js';
import { EventTypeSchema } from './classification-override.js';
import { DecimalStringSchema } from './primitives.js';

/** Wire format: `amount` is a decimal string (Decimal serialized). */
export const ClassifiedEventSchema = z.object({
  id: z.number().int().positive(),
  rawTxId: z.number().int().positive(),
  txHash: z.string(),
  chainId: z.number().int(),
  logIndexRef: z.number().int(),
  walletId: z.number().int().positive(),
  eventType: EventTypeSchema,
  tag: z.enum(ACCOUNTING_TAGS).optional(),
  swapGroupId: z.string().nullable(),
  assetId: z.number().int().positive(),
  amount: DecimalStringSchema,
  direction: z.union([z.literal(1), z.literal(-1)]),
  counterparty: z.string().nullable(),
  counterpartyLabel: z.string().nullable(),
  occurredAt: z.number().int(),
  notes: z.string().nullable(),
});
